import format from "date-fns/format";
import { DATE_FORMAT_API } from "./dateConstants";

export const transformToApiFetch = (date: string) => format(new Date(date), DATE_FORMAT_API);
